import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';

class SideMenuItem extends Component {
    // Route props
    static propTypes = {
        location: PropTypes.object.isRequired
    };

    render = () => {
        return (
            <li className={'side-menu-item ' + this.props.extraClasses}>
                <Link to={'/' + this.props.url}>
                    <div className="unread-marker" />
                    <div className="link">
                        <img width={this.props.iconWidth} height={this.props.iconHeight} src={this.getIcon()} alt="" />
                        <h3>{this.props.label}</h3>
                        <div className={this.getClass()} />
                    </div>
                </Link>
            </li>
        );
    };

    getIcon() {
        var extension = '.svg';
        if (this.isActive()) {
            extension = '_fill' + extension;
        }

        var iconPath = 'assets/images/sidemenu/' + this.props.icon + extension;
        return iconPath;
    }

    getClass() {
        var classNames = 'menu-marker';
        if (this.isActive()) {
            classNames += ' active';
        } else {
            classNames += ' inactive';
        }

        return classNames;
    }

    // Check if menu item is active depending on present route
    isActive() {
        const { location } = this.props;
        return location.pathname.startsWith('/' + this.props.url) ? true : false;
    }
}

export default withRouter(connect()(SideMenuItem));



// WEBPACK FOOTER //
// ./src/components/shared/sidemenu/SideMenuItem.js